export default "__VITE_ASSET__DpD3UzIE__"